/**
 * Page types for search vacant API
 * Determines which API endpoint to call
 */
export enum PageType {
  VACANT = 'vacant',
  SKI = 'ski',
  AREA = 'area',
  MIDNIGHT = 'midnight',
  AIR = 'air',
  ENSEN = 'ensen',
}

/**
 * URL query parameter keys
 */
export enum URL_KEYS {
  /** AmountInput */
  CHILDREN_UPPER_GRADE = 'f_s1',
  CHILDREN_LOWER_GRADE = 'f_s2',
  INFANT_BED_MEALS = 'f_y1',
  INFANT_MEAL = 'f_y2',
  INFANT_BED = 'f_y3',
  INFANT_NONE = 'f_y4',
  NO_OF_UNITS = 'f_heya_su',
  ADULTS = 'f_otona_su',
  /** DateInput */
  CHECK_IN_DAY = 'f_hi1',
  CHECK_IN_MONTH = 'f_tuki1',
  CHECK_IN_YEAR = 'f_nen1',
  CHECK_OUT_DAY = 'f_hi2',
  CHECK_OUT_MONTH = 'f_tuki2',
  CHECK_OUT_YEAR = 'f_nen2',
  /** Common - Domestic & Overseas */
  SORT = 'f_sort',
  DAI = 'f_dai',
  /** Common - Domestic */
  HYOJI = 'f_hyoji',
  SQUEEZES = 'f_squeezes',
  /** Price */
  KIN = 'f_kin',
  KIN2 = 'f_kin2',
  /** Hotel List */
  NUMBER = 'f_no',
}
